import { Box, Skeleton, styled } from '@mui/material';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';
import { IdField } from '.';

export const LabelValueBox = styled(Box)(({ theme }) => ({
    alignItems: 'center',
    gap: theme.spacing(0.5),
}));

export const LabelText = styled(Typography)(({ theme }) => ({
    fontSize: 11,
    fontWeight: 500,
    lineHeight: 1.2,
    marginBottom: 3,
    color: theme.palette.text.secondary,
}));

export const ValueText = styled(Typography)(() => ({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineHeight: 1.2,
    fontSize: 14,
}));

export const Textarea = styled(Typography)(() => ({
    lineHeight: 1.2,
    fontSize: 14,
}));

type LabelValueProps = {
    id: string;
    label: string;
};

export const LabelIdValue = ({ id, label }: LabelValueProps) => {
    return (
        <LabelValueBox>
            <LabelText>{`${label}:`}</LabelText>
            <IdField
                id={id}
                label={undefined}
                typographyProps={{ fontSize: 14 }}
            />
        </LabelValueBox>
    );
};

type LabeledValueProps = {
    label: string;
    value?: string | number | ReactNode;
    loading?: boolean;
};

export const LabeledValue = ({
    label,
    value = 'Unknown',
    loading = false,
}: LabeledValueProps) => {
    const randomWidth = 50 + Math.random() * 100;
    return (
        <LabelValueBox>
            <LabelText>{label}</LabelText>
            {loading ? (
                <Skeleton width={randomWidth} height={14} />
            ) : (
                <ValueText>{value ?? 'Unknown'}</ValueText>
            )}
        </LabelValueBox>
    );
};

export const LabeledTextarea = ({
    label,
    value = 'Unknown',
    loading = false,
}: LabeledValueProps) => {
    const randomWidth = 50 + Math.random() * 100;
    return (
        <LabelValueBox>
            <LabelText>{label}</LabelText>
            {loading ? (
                <Skeleton width={randomWidth} height={14} />
            ) : (
                <Textarea>{value ?? 'Unknown'}</Textarea>
            )}
        </LabelValueBox>
    );
};
